import { FTSwapAnalyzeObj, TYPE_LIMIT_ACCEPT } from "@/constants";
import { useCommonStore } from "@/stores";
import { heic2jpeg, isHeic, isTiff, selectFile, tiff2png } from "@/utils";
import FTAnalytic from '@/analyze/FTAnalytic';

const useCustomTemp = () => {
  const chooseTemp = useCommonStore(state => state.chooseTemp);

  const handleCustomTemp = async () => {
    try {
      const [file] = await selectFile({ accept: TYPE_LIMIT_ACCEPT });
      if(isHeic(file)) {
        chooseTemp(await heic2jpeg(file))
      }else if (isTiff(file)) {
        chooseTemp(await tiff2png(file));
      } else {
        chooseTemp(file);
      }
    } catch (err) {
      console.error(err);
    }
  }

  return {
    handleCustomTemp,
  }
}

export default useCustomTemp;